import LoaderInline from '@jetbrains/ring-ui/components/loader-inline/loader-inline'
import classNames from 'classnames'
import * as React from 'react'

import Icon from '../../../common/Icon/Icon'

import styles from './BuildLogInfo.css'

type Props = {
  type: 'loading' | 'empty' | 'disabled' | 'no-stacktrace'
  className?: string
}

function BuildLogInfo({type, className}: Props) {
  return (
    <div className={classNames(styles.info, className)} data-test-build-log-info>
      {type === 'loading' && <LoaderInline>{'Build log is loading...'}</LoaderInline>}
      {(type === 'empty' || type === 'disabled' || type === 'no-stacktrace') && (
        <Icon name="warning" className={styles.infoIcon} />
      )}
      {type === 'empty' && 'Build log is empty'}
      {type === 'no-stacktrace' && 'No stacktrace'}
      {type === 'disabled' && 'Build log functionality is disabled on server'}
    </div>
  )
}

export default BuildLogInfo
